import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import WhatsAppButton from './components/ui/WhatsAppButton';
import Home from './components/pages/Home';
import About from './components/pages/About';
import OurTeam from './components/pages/OurTeam';
import PromiseToParents from './components/pages/PromiseToParents';
import WhyAureus from './components/pages/WhyAureus';
import Programmes from './components/pages/Programmes';
import Curriculum from './components/pages/Curriculum';
import TermCalendar from './components/pages/TermCalendar';
import Gallery from './components/pages/Gallery';
import Contact from './components/pages/Contact';
import ApplyOnline from './components/pages/ApplyOnline';
import FAQ from './components/pages/FAQ';
import NotFound from './components/pages/NotFound';
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"
function App() {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/promise-to-parents" element={<PromiseToParents />} />
            <Route path="/why-aureus" element={<WhyAureus />} />
            <Route path="/programmes" element={<Programmes />} />
            <Route path="/curriculum" element={<Curriculum />} />
            <Route path="/term-calendar" element={<TermCalendar />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/apply-online" element={<ApplyOnline />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />

        {/* WhatsApp Button */}
        <WhatsAppButton />

        {/* Scroll to Top Button - positioned above WhatsApp button */}
        {showScroll && (
          <button
            onClick={scrollToTop}
            className="fixed z-50 flex items-center justify-center text-white transition-colors duration-200 bg-yellow-400 rounded-full shadow-lg bottom-24 right-6 hover:bg-yellow-500 w-14 h-14"
            aria-label="Scroll to top"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-7 h-7">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
            </svg>
          </button>
        )}
        <SpeedInsights />
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
